import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>Our Story</h2>
        <p>
        We started our company in 2021 as a small family business with the goal to "help the helpers". We believe providers need more than just a paycheck and a constant flow of clients. They also need a dependable support system, work-life-balance, and financial peace-of-mind. At ZENDO HEALTH, we provide all of these.
        </p>
        <p>
        We are in the business of taking care of our providers, so that they can focus on what they do best—taking care of YOU!!!. If you are looking for a provider that is skilled, mindful, and supportive then you have come to the right place. We have someone that can help you find your inner ZEN.
        </p>
        <p>
        We recognize the mind-body connection. We believe that mental health and wellness should be more than just talk therapy. It can be a full sensory experience opening you up to a state of mindfulness and healing. We recommend you consider other wellness services to help you on your journey to improve your health.
        </p>

        <a
          href="https://zendo.health/utah"
          target="_blank"
          rel="noopener noreferrer"
        >
          View our Utah Therapists
        </a> 

        <br />
        <br />
        <a
          href="https://zendo.health/oregon"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist our Oregon Therapists
        </a>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
